// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1J-dT","colMin":"styles_colMin__2koRl","colCheckbox":"styles_colCheckbox__2pKxp"};